/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Section_MarketplaceInputs */

const en_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const es_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mercado`)
};

const fr_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const de_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz`)
};

const ja_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーケットプレイス`)
};

const zh_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场`)
};

const ar_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السوق`)
};

const id_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const it_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const ru_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейс`)
};

const pt_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const ko_footer_section_marketplace = /** @type {(inputs: Footer_Section_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마켓플레이스`)
};

/**
* | output |
* | --- |
* | "Marketplace" |
*
* @param {Footer_Section_MarketplaceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_section_marketplace = /** @type {((inputs?: Footer_Section_MarketplaceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Section_MarketplaceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_section_marketplace(inputs)
	if (locale === "es") return es_footer_section_marketplace(inputs)
	if (locale === "fr") return fr_footer_section_marketplace(inputs)
	if (locale === "de") return de_footer_section_marketplace(inputs)
	if (locale === "ja") return ja_footer_section_marketplace(inputs)
	if (locale === "zh") return zh_footer_section_marketplace(inputs)
	if (locale === "ar") return ar_footer_section_marketplace(inputs)
	if (locale === "id") return id_footer_section_marketplace(inputs)
	if (locale === "it") return it_footer_section_marketplace(inputs)
	if (locale === "ru") return ru_footer_section_marketplace(inputs)
	if (locale === "pt") return pt_footer_section_marketplace(inputs)
	return ko_footer_section_marketplace(inputs)
});